import './Describe.css'
export default function Describe(props: { data: any, index: number }) {
    const { data, index } = props
    return (
        <div className='box' style={index >= 1 ? { marginLeft: 44 } : {}}>
            <div style={{ width: 48, height: 48 }}>
                {data?.icon}
            </div>
            <span className='describeTitle'>
                {data?.title}
            </span>
            <span className='descriptiveInformation'>
                {data?.describe}
            </span>
        </div>
    )
}